import { cn } from '@asad/crane-ui'

export type DeviceTypeIconProps = {
  type?: string
  className?: string
}

type IconVariant = 'overhead' | 'tower' | 'port'

const variantOf = (type?: string): IconVariant => {
  const value = type?.trim().toLowerCase() ?? ''

  if (value.includes('suwnic') || value.includes('overhead') || value.includes('bridge')) return 'overhead'
  if (value.includes('wiez') || value.includes('wież') || value.includes('budowl') || value.includes('tower')) {
    return 'tower'
  }
  if (value.includes('portow') || value.includes('port') || value.includes('gantry')) return 'port'

  return 'overhead'
}

/** Ikona urządzenia dobierana z luźnego pola typu, z bezpiecznym wariantem domyślnym. */
export const DeviceTypeIcon = ({ type, className }: DeviceTypeIconProps) => {
  const common = {
    viewBox: '0 0 32 32',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.7,
    strokeLinecap: 'round' as const,
    className: cn('size-8', className),
    'aria-hidden': true,
  }

  const variant = variantOf(type)

  if (variant === 'tower') {
    return (
      <svg {...common}>
        <path d='M10 28V8M10 8h18M10 8 6 12M24 8v5' />
        <path d='M24 13a2 2 0 1 0 2 2' />
        <path d='M6 28h8M10 12l4-4M10 16l4-4M10 20l4-4M10 24l4-4' />
      </svg>
    )
  }

  if (variant === 'port') {
    return (
      <svg {...common}>
        <path d='M8 28V10l16-6M8 14l10 8' />
        <path d='M18 22v3' />
        <rect x='14' y='25' width='8' height='4' rx='0.5' />
        <path d='M4 28h24' />
      </svg>
    )
  }

  return (
    <svg {...common}>
      <path d='M4 8h24M6 8v18M26 8v18' />
      <rect x='13' y='9.5' width='6' height='4.5' rx='1' />
      <path d='M16 14v6' />
      <path d='M16 20a2.4 2.4 0 1 0 2.4 2.4' />
    </svg>
  )
}
